import { ErrorHandler, Injectable } from "@angular/core";

import { LoggingFactory } from "./logging.factory";
import { Log } from "./logging.model";

@Injectable()
export class GlobalExceptionHandler implements ErrorHandler {
	private logger: Log;

	constructor(logging: LoggingFactory) {
		this.logger = logging.get("globalExceptionHandler");
	}

	handleError(error: any) {
		let errorToLog: string | Error | undefined;
		if (typeof error === "string" || error instanceof Error) {
			errorToLog = error;
		} else {
			// guard against `circular reference` error
			const cache: any[] = [];
			errorToLog = JSON.stringify(error, (_key, value) => {
				if (typeof value === "object" && value !== null) {
					if (cache.indexOf(value) !== -1) {
						// Duplicate reference found, discard key
						return;
					}
					cache.push(value);
				}
				return value;
			});
		}

		this.logger.error("GlobalException", errorToLog);
	}
}
